import { useState } from 'react'
import { LogOut, User, Loader2, ShieldAlert } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import {routes} from '@/lib/routes'
import { useAuth } from '@/contexts/auth-context'
import { SwitchUserDialog } from '@/components/SwitchUserDialog'
import { useI18n } from '@/i18n'
import { permissions } from '@/lib/permissions'

export function IdentitySelector() {
  const i18n = useI18n()
  const navigate = useNavigate()
  const { user, isAuthenticated, isLoading, logout, hasPermission } = useAuth()
  const [switchUserOpen, setSwitchUserOpen] = useState(false)

  // Show loading while checking auth or redirecting to Keycloak
  if (isLoading || !isAuthenticated) {
    return (
      <div className="flex items-center gap-2">
        <Loader2 className="h-4 w-4 animate-spin" />
        <span className="text-sm text-muted-foreground">{i18n.common.loading}</span>
      </div>
    )
  }

  // User is authenticated - show user info (clickable) and logout
  return (
    <div className="flex items-center gap-2">
      <button
        onClick={() => navigate(routes.profile())}
        className="flex items-center gap-2 text-sm hover:text-primary transition-colors"
        data-testid="btn-profile"
      >
        <User className="h-4 w-4" />
        <span className="hidden sm:inline">{user?.name || user?.email}</span>
      </button>
      {hasPermission(permissions.impersonation.switch) && (
        <Button
          variant="ghost"
          size="icon"
          onClick={() => setSwitchUserOpen(true)}
          aria-label={i18n.impersonation.switchUser}
          title={i18n.impersonation.switchUser}
          data-testid="btn-switch-user"
        >
          <ShieldAlert className="h-4 w-4" />
        </Button>
      )}
      <Button variant="ghost" size="icon" onClick={logout} aria-label={i18n.common.logout} data-testid="btn-logout">
        <LogOut className="h-4 w-4" />
      </Button>
      <SwitchUserDialog open={switchUserOpen} onOpenChange={setSwitchUserOpen} />
    </div>
  )
}
